import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { Fragment, memo, useCallback, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import { AuthenticFormVM } from 'front-office/view-models/authentic/authentic-form';
import AuthenticCheckboxes from './form';
import PmiTextField from 'shell/components/shared/text-field';
import IdentityCard from 'front-office/components/shared/identity-card';

const AuthenticAnprComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<AuthenticFormVM>();

  const onChange = useCallback(
    (identifier) => {
      const isSelected =
        formContext.values.authentics?.key.codiceDocumento === identifier.key.codiceDocumento;

      formContext.setFieldValue('authentics', isSelected ? undefined : identifier);

      if (!formContext.values.certificateInternOnly && identifier.dettaglioModalitaRilascio) {
        formContext.setFieldValue(
          'modality',
          isSelected
            ? undefined
            : {
                id: identifier.dettaglioModalitaRilascio.key.codiceModalitaRilascio,
                value: identifier.dettaglioModalitaRilascio.descrizione,
                amountTaxStamp: identifier.dettaglioModalitaRilascio.importoImpostaBollo
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoImpostaBollo)
                  : 0,
                amountRightsSecretariat: identifier.dettaglioModalitaRilascio
                  .importoDirittiSegreteria
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiSegreteria)
                  : 0,
                amountRightsCivilState: identifier.dettaglioModalitaRilascio
                  .importoDirittiStatoCivile
                  ? Number.parseFloat(
                      identifier.dettaglioModalitaRilascio.importoDirittiStatoCivile
                    )
                  : 0,
                amountFixedRights: identifier.dettaglioModalitaRilascio.importoDirittiFissi
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiFissi)
                  : 0,
                amountExpenses: identifier.dettaglioModalitaRilascio.importoSpese
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoSpese)
                  : 0,
                codeExemptionAnpr: identifier.dettaglioModalitaRilascio.codiceEsenzioneAnpr,
                registryType: identifier.dettaglioModalitaRilascio.tipoRegistro,
                descrizioneModalitaStampa:
                  identifier.dettaglioModalitaRilascio.descrizioneModalitaStampa,
                disabled: true,
              }
        );
      }
    },
    [formContext.setFieldValue, formContext.values.authentics]
  );

  const onFieldGeneralityChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('generality', {
        ...formContext.values.generality,
        [key]: value,
      });
    },
    [formContext.values.generality, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-autenthic-anpr-content"
        id="panel-autenthic-anpr-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Autentiche</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <AuthenticCheckboxes onChange={onChange} values={formContext.values.authentics} />
          {formContext.values.authentics ? (
            <Fragment>
              <IdentityCard
                onFieldGeneralityChange={onFieldGeneralityChange}
                generality={
                  formContext.values.accountholder?.account?.generality ||
                  formContext.values.generality
                }
              />
              {formContext.values.authentics.key.codiceDocumento !== '1' ? (
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    label="Nr. Facciate"
                    id="number-face"
                    aria-label="Nr. Facciate"
                    fullWidth
                    type="number"
                    onChange={(event) => {
                      formContext.setFieldValue('numberFacades', event?.target.value);
                    }}
                    value={formContext.values?.numberFacades || ''}
                  />
                </Grid>
              ) : undefined}
              <Grid item xs={12} md={4}>
                <PmiTextField
                  label="Motivo del rilascio"
                  aria-label="Motivo del rilascio"
                  id="reason-release"
                  fullWidth
                  onChange={(event) => {
                    formContext.setFieldValue('reasonRelease', event?.target.value);
                  }}
                  value={formContext.values?.reasonRelease || ''}
                />
              </Grid>
            </Fragment>
          ) : undefined}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

AuthenticAnprComponent.displayName = 'Accordion claims anpr component';

const AuthenticAnpr = memo(AuthenticAnprComponent);

export default AuthenticAnpr;
